// @flow

export const schoolPersonnelModelExtensions = {
  isSchoolAdministrator(): boolean {
    return this.getSchoolPersonnelType() === 'administrator';
  },

  isTeacher(): boolean {
    return this.getSchoolPersonnelType() === 'teacher';
  }
};
